import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './App'
import { UserContextProvider } from './store/userContext'
import { VisitContextProvider } from './store/visitContext'
import { FeedbackContextProvider } from './store/feedbackContext'
import reportWebVitals from './reportWebVitals'
import 'react-notifications/lib/notifications.css'
import 'bootstrap/dist/css/bootstrap.min.css'

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <UserContextProvider>
        <VisitContextProvider>
          <FeedbackContextProvider>
            <App />
          </FeedbackContextProvider>
        </VisitContextProvider>
      </UserContextProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
